import { observer } from 'mobx-react-lite'
import { RightRail } from 'components/DocModes/RightRail'
import cx from 'classnames'
import { useDecisionModeStore } from './useDecisionMode'
import { sortBy } from 'lodash'
import Styles from './DecisionModeRightRail.module.scss'
import { Comment } from './Comment'
import { ReactComponent as GavelIcon } from 'assets/icons/gavel16.svg'
import { Button } from '../Button'
import { useHistory, useParams } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { DocMode } from '../../stores/DocStore.types'
import { useRootStore } from '../../stores/RootStore'
import { CommentableType } from '../ActivityEvent/Types'
import { useReviewsRoutes } from 'hooks/useReviewsRoutes'

export const DecisionModeRightRail = observer(() => {
  const rootStore = useRootStore()
  const store = useDecisionModeStore()
  const history = useHistory()
  const { search, state } = useLocation<{ reviewId: number }>()
  const { slug } = useParams<{ slug: string }>()
  const reviewRoutes = useReviewsRoutes()

  if (!store) {
    return null
  }

  const done = () => {
    setTimeout(() => {
      history.push({
        pathname: reviewRoutes.close({ slug, reviewId: state.reviewId }),
        search,
      })
    }, 250)
    rootStore.docStore?.setDocMode(DocMode.Editor)
  }

  return (
    <RightRail.Root>
      <RightRail.Header>
        <h3 className={Styles.heading}>
          <GavelIcon className={Styles.icon} />
          Link comment(s) to decision
        </h3>
        <p className={Styles.subHeading}>
          Select which comments should be included as references for the decision on this doc.
        </p>
        <RightRail.Actions>
          <Button
            size="lg"
            variant="secondaryGrey"
            isDisabled={!store.decisionCommentIds.length}
            onPress={() => store.clear()}
          >
            Unlink All
          </Button>
          <Button size="lg" variant="secondary" onPress={done}>
            Done
          </Button>
        </RightRail.Actions>
      </RightRail.Header>
      <RightRail.ScrollContent>
        {store.comments.map((comment) => (
          <div className={cx(Styles.itemWrapper)} key={`comment-${comment.id}`}>
            <Comment
              items={[
                comment,
                ...sortBy(rootStore.comments.getByCommentable(comment.id, CommentableType.COMMENT), 'created_at'),
              ]}
            />
          </div>
        ))}
      </RightRail.ScrollContent>
    </RightRail.Root>
  )
})
